/* eslint-disable */
import { OAuthCredential, VerifyCodeCredential } from "../resources";

export const protobufPackage = "store.api.auth.v1";

/** AuthCredentialRequest defines request body of Authentication.VerifyOAuthCredential method. */
export interface AuthCredentialRequest {
  /** Grant type of auth flow. */
  grantType: string;
  /** OAuth credential for sign-in. */
  oauth: OAuthCredential | undefined;
}

export interface SendVerifyCodeRequest {
  /** Required. Verify account */
  verify: VerifyCodeCredential | undefined;
  phone?: string | undefined;
}

export interface SendVerifyCodeResponse {
  /** Indicate whether this account already exist or not. */
  accountExist: boolean;
  /** Resend seconds threshold. */
  resendSeconds: number;
}

export interface SignInWithVerifyCodeRequest {
  /** Verify account */
  verify:
    | VerifyCodeCredential
    | undefined;
  /** 6-digit code string */
  code: string;
}

function createBaseAuthCredentialRequest(): AuthCredentialRequest {
  return { grantType: "", oauth: undefined };
}

export const AuthCredentialRequest = {
  fromJSON(object: any): AuthCredentialRequest {
    return {
      grantType: isSet(object.grantType) ? String(object.grantType) : "",
      oauth: isSet(object.oauth) ? OAuthCredential.fromJSON(object.oauth) : undefined,
    };
  },

  toJSON(message: AuthCredentialRequest): unknown {
    const obj: any = {};
    message.grantType !== undefined && (obj.grantType = message.grantType);
    message.oauth !== undefined && (obj.oauth = message.oauth ? OAuthCredential.toJSON(message.oauth) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<AuthCredentialRequest>, I>>(base?: I): AuthCredentialRequest {
    return AuthCredentialRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<AuthCredentialRequest>, I>>(object: I): AuthCredentialRequest {
    const message = createBaseAuthCredentialRequest();
    message.grantType = object.grantType ?? "";
    message.oauth = (object.oauth !== undefined && object.oauth !== null)
      ? OAuthCredential.fromPartial(object.oauth)
      : undefined;
    return message;
  },
};

function createBaseSendVerifyCodeRequest(): SendVerifyCodeRequest {
  return { verify: undefined, phone: undefined };
}

export const SendVerifyCodeRequest = {
  fromJSON(object: any): SendVerifyCodeRequest {
    return {
      verify: isSet(object.verify) ? VerifyCodeCredential.fromJSON(object.verify) : undefined,
      phone: isSet(object.phone) ? String(object.phone) : undefined,
    };
  },

  toJSON(message: SendVerifyCodeRequest): unknown {
    const obj: any = {};
    message.verify !== undefined &&
      (obj.verify = message.verify ? VerifyCodeCredential.toJSON(message.verify) : undefined);
    message.phone !== undefined && (obj.phone = message.phone);
    return obj;
  },

  create<I extends Exact<DeepPartial<SendVerifyCodeRequest>, I>>(base?: I): SendVerifyCodeRequest {
    return SendVerifyCodeRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<SendVerifyCodeRequest>, I>>(object: I): SendVerifyCodeRequest {
    const message = createBaseSendVerifyCodeRequest();
    message.verify = (object.verify !== undefined && object.verify !== null)
      ? VerifyCodeCredential.fromPartial(object.verify)
      : undefined;
    message.phone = object.phone ?? undefined;
    return message;
  },
};

function createBaseSendVerifyCodeResponse(): SendVerifyCodeResponse {
  return { accountExist: false, resendSeconds: 0 };
}

export const SendVerifyCodeResponse = {
  fromJSON(object: any): SendVerifyCodeResponse {
    return {
      accountExist: isSet(object.accountExist) ? Boolean(object.accountExist) : false,
      resendSeconds: isSet(object.resendSeconds) ? Number(object.resendSeconds) : 0,
    };
  },

  toJSON(message: SendVerifyCodeResponse): unknown {
    const obj: any = {};
    message.accountExist !== undefined && (obj.accountExist = message.accountExist);
    message.resendSeconds !== undefined && (obj.resendSeconds = Math.round(message.resendSeconds));
    return obj;
  },

  create<I extends Exact<DeepPartial<SendVerifyCodeResponse>, I>>(base?: I): SendVerifyCodeResponse {
    return SendVerifyCodeResponse.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<SendVerifyCodeResponse>, I>>(object: I): SendVerifyCodeResponse {
    const message = createBaseSendVerifyCodeResponse();
    message.accountExist = object.accountExist ?? false;
    message.resendSeconds = object.resendSeconds ?? 0;
    return message;
  },
};

function createBaseSignInWithVerifyCodeRequest(): SignInWithVerifyCodeRequest {
  return { verify: undefined, code: "" };
}

export const SignInWithVerifyCodeRequest = {
  fromJSON(object: any): SignInWithVerifyCodeRequest {
    return {
      verify: isSet(object.verify) ? VerifyCodeCredential.fromJSON(object.verify) : undefined,
      code: isSet(object.code) ? String(object.code) : "",
    };
  },

  toJSON(message: SignInWithVerifyCodeRequest): unknown {
    const obj: any = {};
    message.verify !== undefined &&
      (obj.verify = message.verify ? VerifyCodeCredential.toJSON(message.verify) : undefined);
    message.code !== undefined && (obj.code = message.code);
    return obj;
  },

  create<I extends Exact<DeepPartial<SignInWithVerifyCodeRequest>, I>>(base?: I): SignInWithVerifyCodeRequest {
    return SignInWithVerifyCodeRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<SignInWithVerifyCodeRequest>, I>>(object: I): SignInWithVerifyCodeRequest {
    const message = createBaseSignInWithVerifyCodeRequest();
    message.verify = (object.verify !== undefined && object.verify !== null)
      ? VerifyCodeCredential.fromPartial(object.verify)
      : undefined;
    message.code = object.code ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
